export default "__VITE_ASSET__Cn5EdC73__"